import { all, put, call, takeLatest } from 'redux-saga/effects'
import axios from 'portal/utils/axios-msal'

import {
  companiesLoadSuccess,
  companiesLoadFailure,
  COMPANIES_LOAD,
  CompaniesLoadAction
} from './actions'

type CompanyObject = { companyId: string; name: string }
type GenericObject = { companies?: CompanyObject[]; [key: string]: any }

function* companiesLoadSaga(action: CompaniesLoadAction) {
  try {
    let companiesResponse: GenericObject = {}
    const response: { data: GenericObject } = yield call(() =>
      axios.get(`/referencedata/companies`, {
        params: {
          'page[size]': 10000,
          'sort': 'name'
        },
        validateStatus: status => status === 200
      })
    )

    companiesResponse = response && response.data ? { ...response.data } : {}

    yield put(companiesLoadSuccess(companiesResponse))
  } catch (error) {
    console.error(error)
    yield put(companiesLoadFailure(error))
  }
}

export function* watch() {
  yield all([takeLatest(COMPANIES_LOAD, companiesLoadSaga)])
}
